import { IconProps } from './types';

export const IconEdit = ({ height = '24', width = '24', ...props }: IconProps) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.1074 2.94157C15.3629 1.68614 17.3983 1.68614 18.6537 2.94157L21.0584 5.34627C22.3139 6.60169 22.3139 8.63713 21.0584 9.89255L9.92236 21.0286C9.36365 21.5873 8.61044 21.9082 7.82046 21.9241L4.07063 21.9996C2.91781 22.0228 1.97723 21.0822 2.00042 19.9294L2.07586 16.1795C2.09176 15.3896 2.41266 14.6364 2.97138 14.0776L14.1074 2.94157ZM17.2395 4.35578C16.7651 3.88141 15.996 3.88141 15.5217 4.35578L14.6458 5.23161L18.7684 9.35417L19.6442 8.47834C20.1186 8.00397 20.1186 7.23486 19.6442 6.76048L17.2395 4.35578ZM17.3542 10.7684L13.2316 6.64583L6.14583 13.7316L10.2684 17.8542L17.3542 10.7684ZM4.38559 15.4919L4.73162 15.1458L8.85418 19.2684L8.50815 19.6144C8.31466 19.8079 8.05381 19.919 7.78022 19.9245L4.0304 20C4.02408 20.0001 4.0209 19.9991 4.01882 19.9982C4.01597 19.9971 4.01232 19.9949 4.00874 19.9913C4.00515 19.9877 4.00294 19.984 4.00177 19.9812C4.00091 19.9791 3.99989 19.9759 4.00002 19.9696L4.07546 16.2198C4.08096 15.9462 4.1921 15.6853 4.38559 15.4919Z"
                fill="currentColor"
            />
        </svg>
    );
};
